import styled from 'styled-components';

export const PropertyCaption = styled.div`
  margin: 15px 0 0 0;
  color: var(--text-muted);
  font-weight: var(--font-weight-medium);
  font-size: var(--text-xs);
  line-height: 12.1px;
  margin-bottom: 5px;
`;
